module.exports = __webpack_public_path__ + "img/Dantam Hair 15.b3e2452a.jpg";